// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ZVE-","user":"styles_user__2g7SS"};